import { createFileRoute, Navigate } from "@tanstack/react-router";

const CreateAccountRoute = () => {
  return <Navigate to="/onboarding/company-setup" replace />;
};

export const Route = createFileRoute("/auth/accounts")({
  component: CreateAccountRoute,
});
